import { api, unwrap } from '@/api'
import type { CustomerPermissionsSummary, CustomerSubscriptionSummary } from '@/modules/customer'
import type { SellerDashboardData, SellerInventorySummary, SellerUsageLimits } from '../types/seller.types'

export const sellerService = {
  async getDashboard(): Promise<SellerDashboardData> {
    const res = await api.get<SellerDashboardData>('/seller/dashboard')
    return unwrap(res)
  },

  async getInventorySummary(): Promise<SellerInventorySummary> {
    const res = await api.get<SellerInventorySummary>('/seller/inventory-summary')
    return unwrap(res)
  },

  async getUsage(): Promise<SellerUsageLimits> {
    const res = await api.get<SellerUsageLimits>('/seller/usage')
    return unwrap(res)
  },

  async getSubscription(): Promise<CustomerSubscriptionSummary | null> {
    const res = await api.get<CustomerSubscriptionSummary | null>('/seller/subscription')
    return unwrap(res)
  },

  async getPermissions(): Promise<CustomerPermissionsSummary> {
    const res = await api.get<CustomerPermissionsSummary>('/seller/permissions')
    return unwrap(res)
  },
}
